import React from 'react';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useToggleModal } from '@hooks';

import { IconButtonV2 } from 'components/common/ui';
import { ModalFormSection } from 'components/common/modals';
import { ModalV2 } from 'components/common/modals/ModalV2';

import UserMediaUploadDocumentForm from '../UserMediaUploadDocumentForm';
import styles from './userMediaUploadDocument.styles';

const UserMediaUploadDocument = ({ onSubmit, isLoading }) => {
  const { isOpen, handleClose, handleOpen } = useToggleModal();

  const handleSubmit = async (values) => {
    await onSubmit(values);
    handleClose();
  };

  return (
    <>
      <IconButtonV2 onClick={handleOpen} size="small">
        <Box sx={styles.buttonWrapper}>
          <AddIcon data-testid="AddIcon" fontSize="small" />
          Add Document
          <ExpandMoreIcon data-testid="ExpandMoreIcon" fontSize="small" />
        </Box>
      </IconButtonV2>
      <ModalV2
        id="add-new-document-modal"
        title="Upload New Document"
        isOpen={isOpen}
        size="sm"
        maxWidth="sm"
        onClose={handleClose}
      >
        <ModalFormSection>
          <UserMediaUploadDocumentForm
            onSubmit={handleSubmit}
            onCancel={handleClose}
            isLoading={isLoading}
          />
        </ModalFormSection>
      </ModalV2>
    </>
  );
};

export default UserMediaUploadDocument;
